import type { ReactNode } from 'react';

import styles from './Notice.module.css';

export interface NoticeProps {
  /**
   * `error`: something failed; say what happened and how to fix it. Announced at once.
   * `info`: context the person should read before acting. Neither uses danger red,
   * which is reserved for clinical danger.
   */
  tone: 'error' | 'info';
  children: ReactNode;
  /** One action that resolves it, e.g. a "Try again" button. */
  action?: ReactNode;
}

export function Notice({ tone, children, action }: NoticeProps) {
  return (
    <div className={styles.notice} data-tone={tone} role={tone === 'error' ? 'alert' : 'status'}>
      <div className={styles.text}>{children}</div>
      {action === undefined ? null : <div className={styles.action}>{action}</div>}
    </div>
  );
}
